import React from 'react'
import { CustomerProvider } from './Context'
import { Layout } from './layout'

export const CustomerPage = () => {
  return (
    <CustomerProvider>
      <Layout />
    </CustomerProvider>
  )
}
